import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import { COLOR_LIGHT_BLUE } from "shared/theme/colors";
import { RecentlyPlayedCard } from "./styled";

const RecentlyPlayed: FC = () => {
  return (
    <SpaceBetweenCenter gap={2}>
      {[...Array(5)].map((_, index) => (
        <RecentlyPlayedCard key={`recently-played-games-card-${index}`}>
          <WatchLaterIcon sx={{ fontSize: "54px", color: COLOR_LIGHT_BLUE }} />
        </RecentlyPlayedCard>
      ))}
    </SpaceBetweenCenter>
  );
};

export default RecentlyPlayed;
